import { useAdminAuth } from "context/context";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

const Link = ({ children, type, role, ...rest }) => {
  const { roles } = useAdminAuth();
  return (
    <>
      {/* if type is non acl */}
      {type === "acl" &&
        (roles.includes(role) ? (
          <RouterLink {...rest}>{children}</RouterLink>
        ) : (
          <RouterLink to="" className="disabled-link">
            {children}
          </RouterLink>
        ))}

      {/* if type is acl */}
      {type !== "acl" && <RouterLink {...rest}>{children}</RouterLink>}
    </>
  );
};

export default Link;
